<template>
  <div
    class="l-learn-video"
    :class="{
      'hide-play-btn': options ? !!options.hidePlayBtn : false,
      'btn-play-disable': options && !options.canstop,
    }"
  >
    <!-- 播放器 -->
    <div id="aliplayer"></div>
    <slot class="name"></slot>
    <!-- 播放/暂停按钮 -->
    <div class="l-play-btn-mask" v-if="isShow">
      <img src="./images/l-play.png" class="l-big-play-btn" @click="onPlay" alt />
    </div>

    <!-- 弹窗答题 -->
    <div class="l-quiz-popup-mask" v-if="showQuizPopup && currentQuizItem">
      <div class="l-quiz-replay" @click="onReplayQuestion">
        <img src="./images/play.png" class="l-quiz-replay-icon" alt />
        <span>PLAY</span>
      </div>
      <div class="l-quiz-popup">
        <!-- 优先显示选项图片 -->
        <div v-if="hasSelectionImage" class="l-quiz-with-image">
            <div
              v-for="(sel, idx) in currentQuizItem.attrs.selectionList"
              :key="'img-' + idx"
              class="l-quiz-image-item"
            >
              <img
                :src="sel.selectionImageRealUrl || sel.selectionImageUrl"
                class="l-quiz-image"
                alt
              />
              <div
                class="l-quiz-option"
                :class="{ 'is-disabled': feedbackType || !canSelectAnswer }"
                @click="onSelectOption(sel, idx)"
              >
                <!-- A/B 图标 -->
                <img
                  :src="getOptionBaseImage(sel)"
                  class="l-quiz-option-img small"
                  alt
                />
                <!-- 选择正确：在正确选项显示对勾 -->
                <img
                  v-if="feedbackType === FEEDBACK_TYPE.CORRECT && sel.isRight === 1"
                  :src="correctImg"
                  class="l-quiz-option-overlay small"
                  alt
                />
                <!-- 选择错误：在当前选项显示叉号 -->
                <img
                  v-if="feedbackType === FEEDBACK_TYPE.WRONG && selectedOptionIndex === idx"
                  :src="wrongImg"
                  class="l-quiz-option-overlay small"
                  alt
                />
              </div>
            </div>
        </div>
        <!-- 如果没有选项图片，则展示题干图片 -->
        <div v-else-if="hasQuestionImageUrl" class="l-quiz-with-question-image">
            <img
              :src="currentQuizItem.attrs.questionImageRealUrl"
              class="l-quiz-question-image"
              alt
            />
            <div class="l-quiz-options">
              <div
                v-for="(sel, idx) in currentQuizItem.attrs.selectionList"
                :key="'img-' + idx"
                class="l-quiz-image-item"
              >
                <div
                  class="l-quiz-option"
                  :class="{ 'is-disabled': feedbackType || !canSelectAnswer }"
                  @click="onSelectOption(sel, idx)"
                >
                  <!-- A/B 图标 -->
                  <img
                    :src="getOptionBaseImage(sel)"
                    class="l-quiz-option-img small"
                    alt
                  />
                  <!-- 选择正确：在正确选项显示对勾 -->
                  <img
                    v-if="feedbackType === FEEDBACK_TYPE.CORRECT && sel.isRight === 1"
                    :src="correctImg"
                    class="l-quiz-option-overlay small"
                    alt
                  />
                  <!-- 选择错误：在当前选项显示叉号 -->
                  <img
                    v-if="feedbackType === FEEDBACK_TYPE.WRONG && selectedOptionIndex === idx"
                    :src="wrongImg"
                    class="l-quiz-option-overlay small"
                    alt
                  />
                </div>
              </div>
            </div>
        </div>

        <!-- 不带 selectionImageUrl：仅展示 A/B 图标，选择后在当前选项显示对勾/叉号 -->
        <div v-else class="l-quiz-no-image">
          <div class="l-quiz-options">
            <div
              v-for="(sel, idx) in currentQuizItem.attrs.selectionList"
              :key="idx"
              class="l-quiz-option"
              :class="{ 'is-disabled': feedbackType || !canSelectAnswer }"
              @click="onSelectOption(sel, idx)"
            >
              <img
                :src="getOptionBaseImage(sel)"
                class="l-quiz-option-img"
                alt
              />
              <!-- 选择正确：在当前（正确）选项显示对勾 -->
              <img
                v-if="feedbackType === FEEDBACK_TYPE.CORRECT && selectedOptionIndex === idx"
                :src="correctImg"
                class="l-quiz-option-overlay"
                alt
              />
              <!-- 选择错误：在当前（错误）选项显示叉号 -->
              <img
                v-if="feedbackType === FEEDBACK_TYPE.WRONG && selectedOptionIndex === idx"
                :src="wrongImg"
                class="l-quiz-option-overlay"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aliplayer from '@/utils/aliplayer'
import UserModel from '@/models/usercenter'
import UPModel from '@/models/imgup'
import { createNamespacedHelpers } from 'vuex'
import { recordStudyPlayData } from '@/utils/record'
import elementTypes from '../../minxin/elementTypes'
import CorrectAudio from '@/assets/audio/correct.mp3'
import ErrorAudio from '@/assets/audio/error.mp3'

const { mapGetters, mapActions } = createNamespacedHelpers('course')
const user = new UserModel()
const upModel = new UPModel()

// 弹窗答题反馈类型
const FEEDBACK_TYPE = {
  NONE: '',
  CORRECT: 'correct',
  WRONG: 'wrong',
}

export default {
  name: 'l-learn-explain-and-understand',
  props: {
    /**
     *  vid:视频vid
     *  autoplay: 是否自动播放;默认 false
     *  canstop: 是否可禁用播放按钮;默认 true
     *  hidePlayBtn: 是否隐藏播放按钮;默认 false
     */
    options: {
      type: Object,
      default: () => {
        return {
          autoplay: false,
          control: true,
          hidePlayBtn: false,
          canstop: true,
          isEnded: false, // 播放完成
        }
      },
    },
  },
  mixins: [elementTypes],
  data() {
    return {
      FEEDBACK_TYPE,
      player: null,
      params: {},
      mark: '',
      isShow: true,
      waterMarker: {},
      videoData: {},
      playTimer: null,
      playTime: 0, // 进入页面开始播放的播放时长
      // 弹窗答题
      showQuizPopup: false,
      currentQuizItem: null,
      shownQuizIndexes: [], // 已显示过的题目下标，避免重复弹窗
      quizData: [], // 源数据加工后的测验数据（带完整资源路径）
      feedbackType: FEEDBACK_TYPE.NONE,
      selectedOptionIndex: null, // 选中的选项下标，用于替换成反馈图
      questionAudio: null, // 题干音频实例
      canSelectAnswer: true, // 题干音频播完后才允许选答案
      rightAudioScheduled: false, // 选错时是否已安排播放正确音频，防重复
      optionAImg: require('./images/option-a.png'),
      optionBImg: require('./images/option-b.png'),
      correctImg: require('./images/right.png'),
      wrongImg: require('./images/wrong.png'),
    }
  },
  computed: {
    // element下的 datas 和 records 数据类型：
    /**
     * datas:{
        "id": 1037064,
        "name": "GZC010010101",
        "type": 904,
        "done": null,
        "lock": null,
        "attrs": {
            "offset": 13, // 单位秒
            "rightAudioUrl": "course/语课/感/感初/新秀1段/第55关卡/The Foolish Bear/GZC010010101/GZC010010101_R.mp3?versionId=CAEQeRiBgIDD7pS74BkiIDk4Y2NkZDQ2Y2M3YzRhNTNhMmJiZjU5ZWM5YzA1Y2Nj",
            "questionImageUrlName": "GZC010010101.gif",
            "questionAudioUrlName": "GZC010010101.mp3",
            "origQuestionAudioUrl": "武功/01GZC01/GZC01055#新课/01#The Foolish Bear/01#讲解与理解#The Foolish Bear/GZC010010101.mp3",
            "questionAudioUrl": "course/语课/感/感初/新秀1段/第55关卡/The Foolish Bear/GZC010010101/GZC010010101.mp3?versionId=CAEQeRiBgICP.pS74BkiIDc0OTgyNzNlYjlmNjQwNGY4NWQ0MzAzYjk2YWI3NTc5",
            "wrongAudioUrlName": "GZC010010101_W.mp3",
            "questionImageUrl": "course/语课/感/感初/新秀1段/第55关卡/The Foolish Bear/GZC010010101/GZC010010101.gif?versionId=CAEQeRiBgIDC7ZS74BkiIDBkZTRjMjkxMmQyNDQwNTQ5Yzc3MTZhMTdmZDQ4ODBi",
            "selectionList": [
                {
                    "name": "A",
                    "isRight": 1,
                    "origSelectionAudioUrl": "武功/01GZC01/GZC01055#新课/01#The Foolish Bear/01#讲解与理解#The Foolish Bear/GZC010010101_A.mp3",
                    "selectionAudioUrl": "course/语课/感/感初/新秀1段/第55关卡/The Foolish Bear/GZC010010101/GZC010010101_A.mp3?versionId=CAEQeRiBgMCs9ZS74BkiIDU5Yjg0NWMyZTZlNDQ0YWJhOGQxMDY4MWJiMzY2MzQw",
                    "selectionAudioUrlName": "GZC010010101_A.mp3",
                    selectionImageUrl: "course/2026/02/06/基础女套装.png?versionId=CAEQehiBgMCusKXH4RkiIGQzNjNlY2MzYjVjMDQxZDE5ZGE5ZGJjMDc0MjI3YWUw",
                },
                {
                    "name": "B",
                    "isRight": 0,
                    "origSelectionAudioUrl": "武功/01GZC01/GZC01055#新课/01#The Foolish Bear/01#讲解与理解#The Foolish Bear/GZC010010101_B.mp3",
                    "selectionAudioUrl": "course/语课/感/感初/新秀1段/第55关卡/The Foolish Bear/GZC010010101/GZC010010101_B.mp3?versionId=CAEQeRiBgICC95S74BkiIDJlYjA2NTAyNDM2ODRkMTU4ZDFmZjhmYjVkZmFjZjc4",
                    "selectionAudioUrlName": "GZC010010101_B.mp3",
                    selectionImageUrl: "course/2026/02/06/基础女套装.png?versionId=CAEQehiBgMCusKXH4RkiIGQzNjNlY2MzYjVjMDQxZDE5ZGE5ZGJjMDc0MjI3YWUw",
                }
            ],
            "rightAudioUrlName": "GZC010010101_R.mp3",
            "wrongAudioUrl": "course/语课/感/感初/新秀1段/第55关卡/The Foolish Bear/GZC010010101/GZC010010101_W.mp3?versionId=CAEQeRiBgICZ75S74BkiIDEwZTg4NDUxYjY3NjQ4OWRhYzgwMmNlMDdhZDE0ZTc5"
        },
        "datas": null,
        "snum": null,
        "rnum": null
    }[],
    records:  
        {
            "eleId": 1037064,
            "right": true,
            "id": 1564404642,
            "time": 1770205116000,
            "summary": "你本次的结果不理想！再接再厉哦！"
        }[]
     */
    ...mapGetters(['element']),
    LOCK_KEY() {
      return `VIDEO_TIME_${this.element.RECORD_ID}`
    },
    quizList() {
      // 优先使用已经加工过的 quizData（带完整资源路径）
      const datas = this.quizData && this.quizData.length
        ? this.quizData
        : this.element && this.element.datas
      return Array.isArray(datas) ? datas : []
    },
    // 当前题是否有 selectionImageUrl，用于决定使用哪种 UI
    hasSelectionImage() {
      const item = this.currentQuizItem
      const list =
        item && item.attrs && Array.isArray(item.attrs.selectionList)
          ? item.attrs.selectionList
          : []
      return list.length > 0 && !!list[0].selectionImageUrl
    },
    hasQuestionImageUrl() {
      const item = this.currentQuizItem
      return item && item.attrs && item.attrs.questionImageUrl
    },
  },
  watch: {
    'element.isSubmit'(to) {
      if (to && this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.EXPLAIN_AND_UNDERSTAND) {
        localStorage.removeItem(this.LOCK_KEY)
      }
    },
    'element.isCallBack'() {
      if (this.player) {
        if (this.player.getStatus() === 'pause') {
          this.$emit('back')
          return
        }
        this.$emit('back')
      }
    },
    // element.datas 变化时，预处理测验数据（生成完整资源路径）
    'element.datas': {
      immediate: true,
      handler() {
        this._initQuizData()
      },
    },
    options: {
      deep: true, // 深度监听
      handler(newVal, oldVal) {
        if (newVal.vid != oldVal.vid) {
          this.player ? this.player.dispose() : null
          this._initPlayer()
        }
      },
    },
  },
  methods: {
    ...mapActions(['STUDY_RESULT']),

    // 初始化测验数据：为 questionAudioUrl 和 selectionImageUrl 生成完整路径
    async _initQuizData() {
      const rawDatas =
        this.element && Array.isArray(this.element.datas)
          ? this.element.datas
          : []
      if (!rawDatas.length) {
        this.quizData = []
        return
      }

      // 收集需要转换的资源路径
      const paths = []
      rawDatas.forEach((item) => {
        const attrs = item.attrs || {}
        if (attrs.questionAudioUrl) {
          paths.push(attrs.questionAudioUrl)
        }
        if (attrs.questionImageUrl) {
          paths.push(attrs.questionImageUrl)
        }
        (attrs.selectionList || []).forEach((sel) => {
          if (sel.selectionImageUrl) {
            paths.push(sel.selectionImageUrl)
          }
        })
      })

      if (!paths.length) {
        this.quizData = rawDatas
        return
      }

      try {
        const map = await this.getFullResources(paths)
        this.quizData = rawDatas.map((item) => {
          const attrs = item.attrs || {}
          const selectionList = (attrs.selectionList || []).map((sel) => ({
            ...sel,
            // selectionImageRealUrl 使用 resource 返回的完整路径
            selectionImageRealUrl: sel.selectionImageUrl
              ? map[sel.selectionImageUrl]
              : '',
          }))
          return {
            ...item,
            attrs: {
              ...attrs,
              // questionAudioRealUrl 使用 resource 返回的完整路径
              questionAudioRealUrl: attrs.questionAudioUrl
                ? map[attrs.questionAudioUrl]
                : '',
              questionImageRealUrl: attrs.questionImageUrl
                ? map[attrs.questionImageUrl]
                : '',
              selectionList,
            },
          }
        })
      } catch (err) {
        console.error('初始化测验资源失败:', err)
        this.quizData = rawDatas
      }
    },

    // 根据资源路径，获取资源（音频和图片）完整路径
    getFullResources(paths) {
      return new Promise((resolve, reject) => {
        if (!paths.length) {
          resolve({});
          return;
        }
        
        upModel.resource({ paths })
          .then((res) => {
            // Create a map of original path to full URL
            const resourceMap = {};
            if (res && res.data && Array.isArray(res.data)) {
              paths.forEach((path, index) => {
                resourceMap[path] = res.data[index];
              });
            }
            resolve(resourceMap);
          })
          .catch((err) => {
            console.error('Error loading resources:', err);
            reject(err);
          });
      });
    },
    onPlay() {
      this.player.play()
    },
    onPlayEnd() {
      this.player ? this.player.pause() : null
    },
    //设置播放器音量
    setVolume(volume) {
      this.player.setVolume(volume)
    },
    dispose() {
      this.player.dispose()
    },
    async _mark() {
      let res = await user.phone()

      this.mark = res.data.phone
    },
    _initPlayer() {
      aliplayer({
        ...(this.options || this.params),
        mark: this.mark,
        selector: 'aliplayer',
        // dbClickFullscreen: false,
        // skinLayoutIgnore: ['controlBar.fullScreenButton'],
        noFullScreen: true,
        noQuality: true,
        currentKeyValue: this.LOCK_KEY,
      }).then((player) => {
        this.player = player
        let time = localStorage.getItem(this.LOCK_KEY)
        this.player.seek(Number(time))
        this._initEvent()
      })
    },
    // 绑定事件
    _initEvent() {
      this.player.on('ready', () => {
        this.$emit('ready', {
          duration: this.player.getDuration()
            ? this.player.getDuration()
            : this.player.videoTotalTime,
          volume: this.player.getVolume(),
        })
      })
      // 绑定事件
      this.player.on('play', () => {
        if (this.playTimer) {
          clearInterval(this.playTimer)
        }
        this._countTime()
        this.isShow = false
        this.$emit('play')
      })

      // 播放暂停
      this.player.on('pause', () => {
        clearInterval(this.playTimer)
        this.isShow = true
        this.$emit('pause')
      })

      // 播放结束
      this.player.on('ended', () => {
        clearInterval(this.playTimer)
        recordStudyPlayData({
          id: this.element.id,
          bizType: this.element.type,
          type: 1,
          offset: this.playTime,
        }, this.element.ELEMENT_TYPE)

        this.isEnded = true
        this.$emit('submit')
      })

      this.player.on('timeupdate', () => {
        const currentTime = this.player.getCurrentTime()
        localStorage.setItem(
          this.LOCK_KEY,
          this.player.getCurrentTime()
        )
        // 弹窗答题：到达 offset 时显示选择弹窗
        this._checkQuizPopup(currentTime)
        this.$emit('update', {
          currentTime: this.player.getCurrentTime(),
        })
      })
    },

    // 播放计时
    _countTime() {
      this.playTimer = setInterval(() => {
        this.playTime += 1
      }, 1000)
    },

    // 检查是否到达某题 offset，显示弹窗并播放题干（已作答的根据 element.records 过滤）
    async _checkQuizPopup(currentTime) {
      if (!this.quizList.length || this.showQuizPopup) return
      const records = this.element.records || []
      for (let i = 0; i < this.quizList.length; i++) {
        if (records[i]) continue // 已作答过，跳过
        if (this.shownQuizIndexes.indexOf(i) >= 0) continue
        const item = this.quizList[i]
        const offset = item.attrs && item.attrs.offset
        if (offset != null && currentTime >= offset) {
          this.shownQuizIndexes.push(i)
          this.currentQuizItem = item
          this.showQuizPopup = true
          this.feedbackType = FEEDBACK_TYPE.NONE
          this.player.pause()
          await this._playQuestionAudio()
          return
        }
      }
    },
    // 使用预处理后的 questionAudioRealUrl/questionAudioUrl 播放题干
    async _playQuestionAudio() {
      if (!this.currentQuizItem || !this.currentQuizItem.attrs) return
      const attrs = this.currentQuizItem.attrs
      const url =
        attrs.questionAudioRealUrl || attrs.questionAudioUrl || ''
      if (!url) {
        this.canSelectAnswer = true
        return
      }
      try {
        this._stopQuestionAudio()
        this.canSelectAnswer = false
        this.questionAudio = new Audio(url)
        this.questionAudio.onended = () => {
          this.canSelectAnswer = true
        }
        this.questionAudio.onerror = () => {
          this.canSelectAnswer = true
        }
        this.questionAudio.play().catch((e) => {
          this.canSelectAnswer = true
          console.warn('题干播放失败', e)
        })
      } catch (e) {
        this.canSelectAnswer = true
        console.warn('题干播放失败', e)
      }
    },
    _stopQuestionAudio() {
      if (this.questionAudio) {
        this.questionAudio.pause()
        this.questionAudio.currentTime = 0
        this.questionAudio = null
      }
    },
    onReplayQuestion() {
      this._playQuestionAudio()
    },
    // 选项图片：选完后当前选项显示反馈图，否则显示 A/B 原图
    getOptionBaseImage(sel) {
      return sel.name === 'A' ? this.optionAImg : this.optionBImg
    },
    onSelectOption(selection, idx) {
      if (this.feedbackType) return
      if (!this.canSelectAnswer) return
      const isRight = selection.isRight === 1
      this.selectedOptionIndex = idx
      this.feedbackType = isRight ? FEEDBACK_TYPE.CORRECT : FEEDBACK_TYPE.WRONG
      this._stopQuestionAudio()
      // 提交答案
      this.STUDY_RESULT({
        elementId: this.element.id,
        postData: {
          eleId: this.currentQuizItem.id,
          right: isRight,
          suggestedScore: isRight ? 100 : 0,
        },
      });
      // 播放反馈音频
      const feedback = new Audio(isRight ? CorrectAudio : ErrorAudio)
      feedback.play().catch((e) => console.warn('反馈音频播放失败', e))
      feedback.onended = () => {
        if (isRight) {
          this.closeQuizPopup()
        } else {
          // 选错时继续播放正确答案音频（rightAudioUrl）
          this._playRightAudioThenClose()
        }
      }
      // 若反馈音频未正常结束，3 秒后也关闭（正确）或进入播正确音频流程（错误）
      setTimeout(() => {
        if (!this.showQuizPopup || !this.currentQuizItem) return
        if (isRight) {
          this.closeQuizPopup()
        } else if (!this.rightAudioScheduled) {
          this._playRightAudioThenClose()
        }
      }, 3000)
    },
    // 选错后：播放正确答案音频，结束后关闭弹窗
    async _playRightAudioThenClose() {
      if (this.rightAudioScheduled) return
      this.rightAudioScheduled = true
      const path = this.currentQuizItem?.attrs?.rightAudioUrl
      if (!path) {
        this.closeQuizPopup()
        return
      }
      try {
        const map = await this.getFullResources([path])
        const url = map[path]
        if (!url) {
          this.closeQuizPopup()
          return
        }
        const rightAudio = new Audio(url)
        rightAudio.onended = () => {
          this.closeQuizPopup()
        }
        rightAudio.play().catch((e) => {
          console.warn('正确音频播放失败', e)
          this.closeQuizPopup()
        })
        // 正确音频未正常结束时的兜底关闭
        setTimeout(() => {
          if (this.showQuizPopup && this.currentQuizItem) {
            this.closeQuizPopup()
          }
        }, 15000)
      } catch (e) {
        console.warn('获取正确音频失败', e)
        this.closeQuizPopup()
      }
    },
    closeQuizPopup() {
      this.rightAudioScheduled = false
      this.showQuizPopup = false
      this.currentQuizItem = null
      this.feedbackType = FEEDBACK_TYPE.NONE
      this.selectedOptionIndex = null
      this.canSelectAnswer = true
      this._stopQuestionAudio()
      if (this.player && this.player.getStatus() !== 'ended') {
        this.player.play()
      }
    },
  },
  async created() {
    await this._mark()
  },
  mounted() {
    setTimeout(() => {
      // 对sdk自带的全屏按钮进行隐藏
      let full_screen_btn = document.querySelector('.prism-fullscreen-btn')
      full_screen_btn.style.display = 'none'
      // 对自定义的全屏按钮进行隐藏
      const custom_full_screen_btn = document.querySelector('#full_screen')
      custom_full_screen_btn.style.display = 'none'
    }, 1000)
  },
  destroyed() {
    this._stopQuestionAudio()
    this.showQuizPopup = false
    this.currentQuizItem = null
    this.dispose()
    recordStudyPlayData({
      id: this.element.id,
      bizType: this.element.type,
      type: 1,
      offset: this.playTime,
    }, this.element.ELEMENT_TYPE)
    if (this.playTimer) {
      clearInterval(this.playTimer)
    }
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
